import { I_ApprovalReference } from "src/components/approvals/interfaces"

export const SAFETY_EVENT_RECORD_TYPE_ID = 1

export const getTemplateGroupId = (reference: I_ApprovalReference): number | null =>
  reference.TemplateGroups.find(g =>
    g.Rules.some(r => r.RecordTypeId === SAFETY_EVENT_RECORD_TYPE_ID)
  )?.TemplateGroupId ?? null

export const getPendingStatusTypeId = (reference: I_ApprovalReference): number =>
  reference.ApprovalStatusTypesWithRules.find(s => s.Name === "Pending")?.ApprovalStatusTypeId ?? -1

export const getActionTypeId = (reference: I_ApprovalReference, name: string): number =>
  reference.ApprovalActionTypes.find(a => a.Name === name)?.ApprovalActionTypeId ?? -1
